import * as React from 'react';
import './AccountView.scss';
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import Loader from 'src/components/common/Loader';
import AccountMenu from './components/AccountMenu';
import AccountContent from './components/AccountContent';
import ShipAddressModel from 'src/model/shipAddress.model';
import AccountRequestAlert from './components/AccountRequestAlert';

interface IAccountViewProps {
  isPending: boolean;
  addressRequest: {
    address: ShipAddressModel;
    succed: boolean;
    failed: boolean;
  };
  getArSummary(): void;
  getUserDetails(): void;
  location: any;
  match: any;
  t?: any;
}

export class AccountView extends React.Component<IAccountViewProps, any> {
  public componentDidMount() {
    this.props.getUserDetails();
    this.props.getArSummary();
  }

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-account-view">
        {this.props.isPending ? (
          <Loader />
        ) : this.props.addressRequest.succed ||
          this.props.addressRequest.failed ? (
          <AccountRequestAlert />
        ) : (
          <React.Fragment>
            <Breadcrumbs>
              {t('common.home')} / {t('common.accountInfoBreadCrumb')}
            </Breadcrumbs>
            <div className="page-title">{t('login.myAccount')}</div>

            <div className="container-fluid rp-account-view--container">
              <div className="row">
                <div className="col-12 col-md-3 rp-account-view--menu">
                  <AccountMenu
                    location={this.props.location}
                    match={this.props.match}
                  />
                </div>
                <div className="col-12 col-md-9">
                  <AccountContent match={this.props.match} />
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}
